<template>
    <div class="economy-operations">
        
        <content-switch
        :items="switchItems"
        :selectedItem="selectedItem"
        :counts="counts"
        @selectItem="handleSelectItem($event)" />
        
        <noInvoiceProjects-table v-show="selectedItem === 'noInvoiceProjects'" @finishedLoading="updateCount('noInvoiceProjects', $event)" />
        <unpaidInvoices-table v-show="selectedItem === 'unpaidInvoices'" @finishedLoading="updateCount('unpaidInvoices', $event)" />
        <exceeded-payments v-show="selectedItem === 'exceededPayments'" @finishedLoading="updateCount('exceededPayments', $event)" />
        <all-invoices v-show="selectedItem === 'allInvoices'" @finishedLoading="updateCount('allInvoices', $event)" />
        
    </div>
</template>

<script>
import exceededPayments from './operations/exceededPayments.vue'

export default {
    components: {
        exceededPayments
    },
    data () {
        return {
            selectedItem: 'noInvoiceProjects',
            counts: {
                noInvoiceProjects: null,
                exceededPayments: null,
                allInvoices: null
            },
            switchItems: [
                {
                    name: 'Afsluttede opgaver, der ikke er fakturerede',
                    slug: 'noInvoiceProjects'
                },
                {
                    name: 'Fakturaer, der ikke er betalt',
                    slug: 'unpaidInvoices'
                },
                {
                    name: 'Fakturaer, hvor betalingsfristen er overskredet med ' + this.$store.state.config.companyMeta.settings.overdue_days + ' dage',
                    slug: 'exceededPayments'
                },
                {
                    name: 'Alle fakturaer og kreditnotaer',
                    slug: 'allInvoices'
                }
            ]
        }
    },
    methods: {
        updateCount (slug, event) {
            this.counts[slug] = event
        },
        handleSelectItem (item) {
            this.selectedItem = item
            this.$router.push({
                path: this.$route.path,
                query: {
                    tab: item
                }
            })
        }
    },
    mounted () {
        if (this.$route.query.tab) {
            this.selectedItem = this.$route.query.tab
        }
        this.$store.state.view = 'operations'
        if (this.$route.params.selectedItem) {
            this.selectedItem = this.$route.params.selectedItem
        }
    }
}
</script>



// WEBPACK FOOTER //
// operations.vue?ee468432